import React from 'react';
import { useNavigate } from 'react-router-dom';
import OfferDesktop from '../assets/offer_desktop.png';
import Offer_t from '../assets/offer_tab.png';
import Offer_m from '../assets/offer_mobile.png';

const Offer = () => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/form');
    };

    return (
        <div className="w-full mx-auto cursor-pointer" onClick={handleClick}>
            <picture>
                <source media="(min-width: 1024px)" srcSet={OfferDesktop} />
                <source media="(min-width: 768px)" srcSet={Offer_t} />
                <img
                    src={Offer_m}
                    alt="Responsive content"
                    className="w-full h-auto"
                    style={{ marginBottom: '-6px', marginTop: '-2px' }}
                />
            </picture>
        </div>
    );
};

export default Offer;
